<template>
  <div class="organizational-container">
    <el-card class="box-card organize-content">
      <div slot="header">
        <div class="box-header">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item to="/sys/organizational">权限查看</el-breadcrumb-item>
            <el-breadcrumb-item>权限配置</el-breadcrumb-item>
          </el-breadcrumb>

          <div>
            <el-button v-if="currentState === 0" size="small" type="primary" @click="handleChangeState">配 置</el-button>
            <el-button v-if="currentState === 1" size="small" type="primary" @click="handleCancelState" :loading="confirmLoading">取 消</el-button>

            <el-button
                v-if="currentState === 1"
                size="small"
                type="primary"
                @click="confirmConfig"
                :loading="confirmLoading">
              保 存
            </el-button>
          </div>

        </div>
      </div>
      <div>
        <el-row :gutter="24" class="full-height">
          <!--用户信息 -->
          <el-col class="full-height" :span="6">
            <el-card shadow="hover" class="full-height">
              <div class="filter-bar">
                <span class="filter-title">已选用户</span>
                <el-input
                    class="filter-input"
                    size="small"
                    v-model="username"
                    placeholder="请输入用户名"
                    clearable>
                </el-input>
                <el-button v-if="currentState === 1" type="text" @click="handleUserListAllSelect">
                  <span>{{ userListAllSelectState ? '取消全选' : '全选' }}</span>
                </el-button>
              </div>
              <el-table
                  :data="getComputedUserList"
                  ref="multipleTable"
                  :header-cell-style="{background: '#eef1f6', color: '#606266', fontWeight: 'bolder'}"
                  @row-click="handleTableRowClick"
                  :row-class-name="tableRowClassName"
                  :show-header="false"
                  @cell-mouse-enter="mouseEnterTable"
                  @cell-mouse-leave="mouseLeaveTable">
                <el-table-column
                    align="center"
                    width="55"
                    v-if="currentState === 1">
                  <template slot-scope="scope">
                    <el-checkbox v-model="scope.row.checkAuth" @change="handleTableRowClick(scope.row)"></el-checkbox>
                  </template>
                </el-table-column>

                <el-table-column
                    label="姓名"
                    align="center">
                  <template slot-scope="scope">
                    <div :class="{'user-name-active': currentState === 0 && currentClickUserId === scope.row.userId }">
                      {{ scope.row.realName }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                    label=""
                    align="center">
                  <template slot-scope="scope">
                    <span
                        style="cursor: pointer"
                        @click="configurePermission(scope.row)"
                        v-show="scope.row.dis">
                      特殊权限
                    </span>
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
          </el-col>

          <!--岗位-->
          <el-col class="full-height" :span="9">
            <el-card shadow="hover" class="full-height">
              <div class="filter-bar">
                <span class="filter-title">已选岗位</span>
                <el-input
                    class="filter-input"
                    size="small"
                    v-model="jobName"
                    placeholder="请输入岗位"
                    clearable>
                </el-input>
                <el-button v-if="currentState === 1" type="text" @click="handleListAllSelect(0)">
                  <span>{{ jobListAllSelectState ? '取消全选' : '全选' }}</span>
                </el-button>
              </div>

              <div v-loading="systemLoading" class="scroll-content full-height">
                <div class="box-content" v-if="getAllSystemState(0)">
                  <el-collapse v-model="jobSelectList">
                    <el-collapse-item
                        class="system-select"
                        :name="systemItem.companyName"
                        v-for="(systemItem, index) in initSystemList" :key="systemItem + index"
                        v-show="getComputedSystemList(0, systemItem.positionItemInfoDTOList).length">
                      <template slot="title">
                        <el-checkbox
                            v-if="currentState === 1"
                            v-model="systemItem.positionSelectAll"
                            @change="handleItemAllSelect(0, systemItem)"
                            :indeterminate="getSystemState(0, systemItem) === 1">
                          {{ systemItem.companyName }}系统
                        </el-checkbox>
                        <div v-else>
                          {{ systemItem.companyName }}系统
                        </div>
                      </template>
                      <el-row class="system-select-content" style="padding: 10px">
                        <el-col
                            :span="12"
                            v-for="(item, index) in getComputedSystemList(0, systemItem.positionItemInfoDTOList)"
                            :key="item + index">
                          <el-checkbox
                              v-model="item.checkAuth"
                              @change="handleItemAllSelect(0, systemItem, true)"
                              v-if="currentState === 1">
                            {{ item.positionName }}
                          </el-checkbox>
                          <div v-else style="line-height: 30px">
                            {{ item.positionName }}
                          </div>
                        </el-col>
                      </el-row>
                    </el-collapse-item>
                  </el-collapse>
                </div>


                <div class="el-table__empty-block" style="height: 100%; margin: auto" v-else>
                  <span class="el-table__empty-text">暂无数据</span>
                </div>

              </div>
            </el-card>
          </el-col>

          <!--系统角色-->
          <el-col class="full-height" :span="9">
            <el-card shadow="hover" class="full-height">
              <div class="filter-bar">
                <span class="filter-title">系统角色</span>
                <el-input
                    class="filter-input"
                    size="small"
                    v-model="systemName"
                    placeholder="请输入角色名"
                    clearable>
                </el-input>
                <el-button v-if="currentState === 1" type="text" @click="handleListAllSelect(1)">
                  <span>{{ systemListAllSelectState ? '取消全选' : '全选' }}</span>
                </el-button>
              </div>

              <div v-loading="systemLoading" class="scroll-content full-height">
                <div class="box-content" v-if="getAllSystemState(1)">
                  <el-collapse v-model="roleSelectList">
                    <el-collapse-item
                        class="system-select"
                        :name="systemItem.companyName"
                        v-for="(systemItem) in initSystemList"
                        :key="systemItem.companyName"
                        v-show="getComputedSystemList(1, systemItem.roleItemDTOList).length">
                      <template slot="title">
                        <el-checkbox
                            v-if="currentState === 1"
                            v-model="systemItem.selectAll"
                            @change="handleItemAllSelect(1, systemItem)"
                            :indeterminate="getSystemState(1, systemItem) === 1">
                          {{ systemItem.companyName }}系统
                        </el-checkbox>
                        <div v-else>
                          {{ systemItem.companyName }}系统
                        </div>
                      </template>
                      <el-row class="system-select-content" style="padding: 10px">
                        <el-col :span="8"
                                v-for="(item, index) in getComputedSystemList(1, systemItem.roleItemDTOList)"
                                :key="item + index">
                          <el-checkbox
                              v-model="item.checkAuth"
                              @change="handleItemAllSelect(1, systemItem, true)"
                              v-if="currentState === 1">
                            {{ item.roleName }}
                          </el-checkbox>
                          <div v-else style="line-height: 30px">
                            {{ item.roleName }}
                          </div>
                        </el-col>
                      </el-row>
                    </el-collapse-item>
                  </el-collapse>
                </div>
                <div class="el-table__empty-block" style="height: 100%; margin: auto" v-else>
                  <span class="el-table__empty-text">暂无数据</span>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
import {getDepartInfoList, pageFindUserList, getAllCompanyInfo, configOrganize} from '@/api/organizeMange';
import {unique, debounce} from '@/utils'

export default {
  name: 'Organizational',
  data() {
    return {
      loading: false, // 用户查询加载
      systemLoading: false, // 系统查询加载
      userList: [], // 用户列表
      username: '',
      checkedCompanyList: [], // 选择的系统列表
      systemList: [], // 系统列表
      initSystemList: [], // 默认初始列表
      copyLoading: false,
      initJobList: [],
      systemName: '',  // 系统名字筛选
      jobName: '',  // 岗位名字筛选
      userListAllSelectState: true, // 用户列表是否全选
      jobListAllSelectState: true, // 岗位列表是否全选
      systemListAllSelectState: true, // 系统列表全选
      confirmLoading: false,
      currentState: 0,  // 0代表查看， 1代表修改
      jobSelectList: [],
      roleSelectList: [],
      currentClickUserId: 0,    // 查看当前的用户id
    };
  },

  computed: {
    // 获取用户列表
    getComputedUserList() {
      let input = this.username;
      let items = this.userList;

      if (input) {
        return items.filter(function (item) {
          let userName = item.userName.toString().toLowerCase();
          let engName = item.englishName.toString().toLowerCase();

          if (userName.indexOf(input) !== -1 || engName.indexOf(input) !== -1) {
            return item;
          }
        });
      } else {
        return items;
      }
    },


    // 获取系统 / 岗位列表
    getComputedSystemList() {
      // 0 筛选岗位； 1 筛选角色
      return (type = 0, item) => {
        if (type === 1) {
          return item.filter(roleItemDTOItem => {
            if (this.currentState === 0) {
              return roleItemDTOItem.roleName.indexOf(this.systemName) !== -1 && roleItemDTOItem.checkAuth;
            } else {
              return roleItemDTOItem.roleName.indexOf(this.systemName) !== -1
            }
          });
        } else if (type === 0) {
          return item.filter(roleItemDTOItem => {
            if (this.currentState === 0) {
              return roleItemDTOItem.positionName.indexOf(this.jobName) !== -1 && roleItemDTOItem.checkAuth;
            } else {
              return roleItemDTOItem.positionName.indexOf(this.jobName) !== -1;
            }
          });
        }
      }
    },

    // 系统全部的状态
    getAllSystemState() {
      return (type) => {
        if (this.currentState === 0) {
          let isSelect = false;
          if (this.currentState === 0) {
            for (let i = 0; i < this.initSystemList.length; i++) {
              let item = this.initSystemList[i];
              let state = this.getSystemState(type, item);
              if (state === 1 || state === 0) {
                isSelect = true;
                break;
              }
            }
          }
          return isSelect;
        }
        return true;
      }
    },

    // checkBox选择三种状态
    getSystemState() {
      // 0 筛选岗位； 1 筛选角色
      return (type, item) => {
        let checkAuthName = type === 0 ? 'positionCheckAuth' : 'checkAuth';
        let selectAllName = type === 0 ? 'positionSelectAll' : 'selectAll';

        if (item[selectAllName] && item[checkAuthName]) {
          return 0; // 全选
        } else if (!item[selectAllName] && item[checkAuthName]) {
          return 1; // 部分选择，未全选
        } else if (!item[selectAllName] && !item[checkAuthName]) {
          return 2; // 没有选择
        }
      }
    }
  },

  async created() {
    this.getOrganizeUserList();
    await this.getAllCompanyList();
  },

  methods: {
    // 查询主组织用户列表
    getOrganizeUserList() {
      // 获取已选择的用户list
      this.loading = true
      this.userList = this.$store.state.selectUserList;
      // 设置权限全勾上
      this.userList.forEach(item => {
        this.$set(item, 'checkAuth', true);
      })

      if (this.userList.length <= 0) {
        this.$message.error('暂未选择用户， 1s后将返回权限查看');
        // 跳转到权限查看页面
        setTimeout(() => {
          this.$router.replace('/sys/organizational');
        }, 1000)
      }

      // 查看当前的用户id
      this.currentClickUserId = this.userList[0].userId;
      this.loading = false
    },

    // 查询所有平台
    async getAllCompanyList() {
      this.systemLoading = true;
      let params = {
        userCode: this.currentState === 0 ? this.currentClickUserId : this.userList.filter(item => item.checkAuth).map(item => item.userId).join(','),
        roleName: null
      }
      const res = await getAllCompanyInfo(params);
      if (res.code === '200') {
        this.systemList = res.data
        this.initSystemList = res.data
        this.initSystemList.forEach((item) => {
          if (this.currentState === 0) {
            this.jobSelectList.push(item.companyName)
            this.roleSelectList.push(item.companyName)
          }
          // 设置岗位
          if (item.positionItemInfoDTOList.length) {
            this.$set(item, 'positionSelectAll', true); // 全选
            this.$set(item, 'positionCheckAuth', false); // 已选择
            item.positionItemInfoDTOList.forEach(positionItemInfoDTOItem => {
              if (!positionItemInfoDTOItem.checkAuth) {
                item.positionSelectAll && (item.positionSelectAll = false)
                this.jobListAllSelectState && (this.jobListAllSelectState = false)
              } else {
                !item.positionCheckAuth && (item.positionCheckAuth = true)
              }
            })
          } else {
            this.$set(item, 'positionSelectAll', false); // 全选
            this.$set(item, 'positionCheckAuth', false); // 已选择
          }

          // 设置权限角色
          if (item.roleItemDTOList.length) {
            this.$set(item, 'selectAll', true); // 全选
            this.$set(item, 'checkAuth', false); // 已选择
            item.roleItemDTOList.forEach(roleItemDTOItem => {
              if (!roleItemDTOItem.checkAuth) {
                item.selectAll && (item.selectAll = false)
                this.systemListAllSelectState && (this.systemListAllSelectState = false)
              } else {
                !item.checkAuth && (item.checkAuth = true)
              }
            })
          } else {
            this.$set(item, 'selectAll', false); // 全选
            this.$set(item, 'checkAuth', false); // 已选择
          }
        });

      } else {
        this.$message.error(res.msg)
      }
      this.systemLoading = false;
    },

    // 用户列表全选
    handleUserListAllSelect() {
      // 设置用户全选状态
      this.userListAllSelectState = !this.userListAllSelectState;

      // 设置用户列表
      this.userList = this.userList.map((item) => {
        this.$set(item, 'checkAuth', this.userListAllSelectState);
        return item;
      });

      // 设置请求
      this.getAllCompanyList();
    },

    // 用户列表单选
    handleTableRowClick(row) {
      if (this.currentState === 1) {
        if (row) {
          let selected = row.checkAuth ? !row.checkAuth : true;
          this.$set(row, 'checkAuth', selected);

          // 验证是否全选
          this.userListAllSelectState = this.userList.every(item => item.checkAuth);

          // 获取岗位， 系统信息
          debounce(this.getAllCompanyList, 500);
        }
      } else {
        this.currentClickUserId = row.userId;
        this.getAllCompanyList();
      }
    },

    // 通用全选
    handleListAllSelect(type) {
      let state = type === 0 ? 'jobListAllSelectState' : 'systemListAllSelectState';
      let listName = type === 0 ? 'positionItemInfoDTOList' : 'roleItemDTOList';
      let checkAuthName = type === 0 ? 'positionCheckAuth' : 'checkAuth';
      let selectAllName = type === 0 ? 'positionSelectAll' : 'selectAll';

      // 设置用户全选状态
      this[state] = !this[state];

      // 设置用户列表
      this.initSystemList.forEach((item) => {
        this.$set(item, selectAllName, this[state]);
        this.$set(item, checkAuthName, this[state]);
        item[listName].forEach(childItem => {
          childItem.checkAuth = this[state];
        })
      });
    },

    // 通用子项全选
    handleItemAllSelect(type, row, isChild = false) {
      let state = type === 0 ? 'jobListAllSelectState' : 'systemListAllSelectState';
      let listName = type === 0 ? 'positionItemInfoDTOList' : 'roleItemDTOList';
      let checkAuthName = type === 0 ? 'positionCheckAuth' : 'checkAuth';
      let selectAllName = type === 0 ? 'positionSelectAll' : 'selectAll';

      // 设置子节点
      if (row) {
        if (isChild) {
          if (row[listName].length) {
            let selectAll = true;
            let checkAuth = false;
            // 循环查询是否全选
            row[listName].forEach(item => {
              if (!item.checkAuth) {
                selectAll && (selectAll = false);
              } else {
                !checkAuth && (checkAuth = true);
              }
            })
            // 选择子项，选中父级
            this.$set(row, checkAuthName, checkAuth);
            this.$set(row, selectAllName, selectAll);
          }
        } else {
          this.$set(row, checkAuthName, row[selectAllName]);
          row[listName].forEach(item => {
            item.checkAuth = row[selectAllName]
          })
        }
      }

      let selectAll = true;
      // 验证是否全选
      for (let i = 0; i < this.initSystemList.length; i++) {
        let systemItem = this.initSystemList[i];
        if (!systemItem[selectAllName]) {
          selectAll = false;
          break;
        }
      }
      // 设置全选
      this[state] = selectAll;
    },

    // 修改状态
    async handleChangeState() {
      this.currentState = 1;
      // 设置系统取消
      this.jobSelectList = [];
      this.roleSelectList = [];

      if (this.userList.length > 1) {
        await this.getAllCompanyList();
      }
    },

    // 取消状态
    async handleCancelState() {
      this.currentState = 0;
      await this.getAllCompanyList();
    },


    handleCollapseChange(val) {
      return (type, row) => {
        if (val) {
          let select = type === 0 ? 'positionSelect' : 'select';
          row[select] = !row[select]
        }
      }
    },


    tableRowClassName({row, rowIndex}) {
      if (this.currentState === 0) {
        if (row.userId === this.currentClickUserId) {
          return 'current-row';
        }
        return '';
      }
    },


    // 鼠标移入用户模块 （控制特殊权限使用）
    mouseEnterTable(row) {
      this.$set(row, 'dis', true);
    },

    // 鼠标移除
    mouseLeaveTable(row) {
      this.$set(row, 'dis', false);
    },

    // 特殊权限跳转
    configurePermission(item) {
      this.$router.push({
        path: '/sys/user/custompermission',
        query: {
          id: item.userId
        }
      })
    },

    // 确认配置权限
    async confirmConfig() {
      // 设置已选择用户
      let userList = this.userList.filter(item => item.checkAuth).map(item => item.userId);

      // 设置系统
      let companyIdList = [];
      // 数据操作
      let systemInfoItemDTOList = this.initSystemList.map(item => {
        // 角色
        let roleItemDTOList = item.roleItemDTOList.filter(roleItemDTOItem => {
          return roleItemDTOItem.checkAuth;
        })
        // 岗位
        let positionItemInfoDTOList = item.positionItemInfoDTOList.filter(roleItemDTOItem => {
          return roleItemDTOItem.checkAuth;
        })
        // 有数据
        let checkAuth = !!(roleItemDTOList.length || positionItemInfoDTOList.length);
        if (checkAuth) {
          companyIdList.push(item.companyId);
        }

        // 设置岗位和系统数据
        return {
          ...item,
          roleItemDTOList: roleItemDTOList,
          positionItemInfoDTOList: positionItemInfoDTOList,
          checkAuth: checkAuth,
        };
      }).filter(item => item.checkAuth);


      // 设置加载
      this.confirmLoading = true;
      this.systemLoading = true;

      // 请求参数
      let params = {
        companyIdList: companyIdList,
        userCode: unique(userList).toString(),
        systemInfoItemDTOList: systemInfoItemDTOList
      }

      // /auth/access/accessConfigInfo 权限配置
      const res = await configOrganize(params);

      if (res.code === '200') {
        this.$message.success('配置成功');
        // 设置取消加载
        this.currentState = 0;
        await this.getAllCompanyList();
        this.confirmLoading = false;
        this.systemLoading = false;
      } else {
        this.$message.error(res.msg)
        this.confirmLoading = false;
        this.systemLoading = false;
      }
    },
  }
}

</script>
<style scoped>

::v-deep .el-table td,
::v-deep .el-table th {
  text-align: left !important;
}

::v-deep .el-card_body {
  padding: 10px 20px;
}

::v-deep .box-card {
  flex: 1;
  height: 100%;
}

::v-deep .box-card:nth-child(2) {
  margin: 0 10px;
}

::v-deep .box-card:last-child {
  flex: 2;
}

::v-deep .el-tree-node__content::before {
  content: '';
  padding-left: 10px;
}

::v-deep .el-checkbox__input {
  margin-right: 6px;
}

::v-deep .el-collapse-item__header {
  height: 40px;
  background-color: #f4f4f4;
  padding: 0 10px;
}

::v-deep .levelname {
  margin-right: 10px;
}

::v-deep .el-checkbox__label {
  line-height: 30px;
}

::v-deep .el-radio-group {
  display: flex;
  line-height: 40px;
}

::v-deep .el-radio {
  margin-right: 20px;
}

::v-deep .el-radio__label {
  margin-left: 0;
}

::v-deep .el-icon-edit {
  color: #1a1adf;
}

::v-deep .el-collapse {
  border-bottom: none;
}

::v-deep .el-collapse-item__wrap {
  border-bottom: none;
}

::v-deep .el-table.role-table td.el-table__cell, ::v-deep .el-table.role-table th.el-table__cell.is-leaf {
  border-bottom: none;
}


::v-deep .el-card__body {
  flex: 1;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}


</style>
<style lang='scss' scoped>
.organizational-container {
  width: 100%;
  height: 100%;
  overflow: hidden;

  .container-box {
    display: flex;
    flex-direction: column;
  }

  .el-scrollbar {
    width: 100%;
    height: 100%;
  }

  .container-right {
    display: flex;

    .position-container {
      flex: 1;
    }
  }

  .right-tree {
    border-left: 1px solid #eee;
    border-right: 1px solid #eee;
    margin-bottom: 20px;

    .el-tree {
      margin: 12px 0;
    }
  }

  .filter-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;

    .filter-title {
      line-height: 40px;
      flex: 2;
    }

    .filter-input {
      flex: 5;
      margin-left: 20px;
      margin-right: 20px;
    }
  }

  .system-select {
    margin-bottom: 20px;

    .main-checkbox {
      background-color: rgb(244, 245, 245);
      padding: 10px;
    }
  }

  .box-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .box-content {
    padding: 10px;
  }

  .organize-content {
    display: flex;
    flex-direction: column;

    > .el-card__body {
      > div {
        height: 100%;
        overflow: hidden;

        .full-height {
          height: 100%;
        }

        .el-table, .scroll-content {
          overflow-y: auto;
        }
      }
    }
  }
}
</style>